// material-ui
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

// project imports
import MainCard from "components/MainCard";
import SimpleBar from "components/third-party/SimpleBar";
import { IMemberStatusCountGridModel } from "../../api/types";

// =========================|| DATA WIDGET - Program Wise Members ||========================= //

type Props = {
  data: IMemberStatusCountGridModel[];
};

export default function ProgramWiseMembers({ data }: Props) {
  return (
    <MainCard darkTitle title="Program Wise Members" content={false}>
      <TableContainer sx={{ mt: 0, maxHeight: 390 }}>
        <SimpleBar sx={{ height: 340 }}>
          <Table>
            <TableHead
              sx={{
                position: "sticky",
                top: -1,
                zIndex: 2,
              }}
            >
              <TableRow>
                <TableCell sx={{ pl: 3 }}>Program</TableCell>
                <TableCell align="right" sx={{ pr: 3 }}>
                  Total
                </TableCell>
                <TableCell align="right" sx={{ pr: 3 }}>
                  Approved
                </TableCell>
                <TableCell align="right" sx={{ pr: 3 }}>
                  Pending
                </TableCell>
                <TableCell align="right" sx={{ pr: 3 }}>
                  Rejected
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((row, index) => (
                <TableRow hover key={index}>
                  <TableCell>{row.programName}</TableCell>
                  <TableCell align="right" sx={{ pr: 3 }}>
                    {row.total_Members}
                  </TableCell>
                  <TableCell align="right" sx={{ pr: 3, color: "#52c41a" }}>
                    {row.approved_Members}
                  </TableCell>
                  <TableCell align="right" sx={{ pr: 3, color: "#faad14" }}>
                    {row.pending_Members}
                  </TableCell>
                  <TableCell align="right" sx={{ pr: 3, color: "#EB3434" }}>
                    {row.rejected_Members}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </SimpleBar>
      </TableContainer>
    </MainCard>
  );
}
